import type { FieldMatcher } from '@cdw-ae/filter-bar-interfaces';

export const SelectFromMatcher: FieldMatcher = {
  name: 'selectFrom',
  displayName: 'Select from',
  hasEditor: true,
  options: {
    chipFormatter: (value: string): string => {
      const selected = value.split(',');
      return selected.length > 1
        ? `: ${selected[0]} + ${selected.length - 1} more`
        : value;
    },
  },
  editorOptions: {
    selectionOptions: [],
  },
};